module.exports = __webpack_public_path__ + "assets/img/icon-512x512.78bda6f7.png";